import { useClaimLabelOptions } from "@/admin/hooks/use-claims";
import { selectableLabelOptions } from "@/admin/lib/claim-label-options";

/**
 * Whether this user can add triage labels on this tenant: the tenant has
 * label options configured and the user can edit the claim. Lets a page offer
 * "Labels" from its own menu (see ClaimLabelsControl's `hideAddTrigger`).
 */
export function useCanAddClaimLabels(canEdit: boolean): boolean {
  const { data: options = [] } = useClaimLabelOptions();
  return canEdit && selectableLabelOptions(options).length > 0;
}
